var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 19.3845V0.615479L1.88475 1.84623L3.30775 0.615479L4.73075 1.84623L6.15375 0.615479L7.577 1.84623L9 0.615479L10.423 1.84623L11.8462 0.615479L13.2693 1.84623L14.6923 0.615479L16.1152 1.84623L17.5 0.615479V19.3845L16.1152 18.1537L14.6923 19.3845L13.2693 18.1537L11.8462 19.3845L10.423 18.1537L9 19.3845L7.577 18.1537L6.15375 19.3845L4.73075 18.1537L3.30775 19.3845L1.88475 18.1537L0.5 19.3845ZM3.25 14.4422H14.75V12.9422H3.25V14.4422ZM3.25 10.75H14.75V9.24998H3.25V10.75ZM3.25 7.05773H14.75V5.55773H3.25V7.05773ZM2 17.1H16V2.89998H2V17.1Z",
    fill: "#111111",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoice);
export default __webpack_public_path__ + "static/media/icon-invoice.981c9e855892203ea80aa227a46945ab.svg";
export { ForwardRef as ReactComponent };